module.exports = __webpack_public_path__ + "static/media/us-flag.8ec58318.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/us-flag.svg
// module id = 5289
// module chunks = 11